<div (offClick)="toggle(false)"
     [offClickOff]="!openState.value"
     class="b-a pos-absolute z-2 bg-col-w b-col-5 _content">
    <!-- heading -->
    <button class="p-a flex flex-justify-between col-1 w-12 left"
            (click)="toggle()">
        <!-- title -->
        <span class="block flex-grow w-12 s1">
            @if (titleTpl) {
            <ng-container *ngTemplateOutlet="titleTpl" />
            }
        </span>
        <!-- icon -->
        <div [lineHeightBy]="'s1'">
            <i class="_icon"
               [toggleClassBy]="openState"
               [toggleClass]="'!icon-chevron-down icon-chevron-up'"></i>
        </div>
    </button>

    <!-- body -->

    <div [hideUp]="openState">
        @for (option of options; track option;) {
        <button class="block w-12 left p1 m-l m-r"
                [ngClass]="$first ? '' : 'm-t'"
                [class.m-b]="$last"
                (click)="pick(option);">
            @if (optionTpl) {
            <ng-container *ngTemplateOutlet="optionTpl; context: { $implicit: option }" />
            }
        </button>
        }
    </div>
</div>